export enum EECEventType {
    PRODUCT_CLICK = 'EECproductClick',
}
